import { render, staticRenderFns } from "./Supplied.vue?vue&type=template&id=8a4e56b8&scoped=true&"
import script from "./Supplied.vue?vue&type=script&lang=js&"
export * from "./Supplied.vue?vue&type=script&lang=js&"
import style0 from "./Supplied.vue?vue&type=style&index=0&id=8a4e56b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4e56b8",
  null
  
)

export default component.exports